<template src="./slimCdIntegrationDetail.template.html"></template>
<script>
    import moment from "moment-timezone";
    import * as axios from "axios";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    // import foliomodal from "../../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue"
    Vue.use(VeeValidate);
    export default {
        // components: {
        //     foliomodal
        // },
        name: "slimCdIntegrationDetail",
        props: ["closeSlimCdAccoutPanel", "unitId", "propertyId", "getIntegrationList"],
        data() {
            return {
                gatewayList: [],
                SelectedwheelHouseUser: {},
                clientDetails: {},
                selectedFinalyticUser: {},
                slimCdAccountDetails: {
                    gatewayId: null
                }

            }
        },

        methods: {

            saveConnectionDetails() {
                let vm = this;
                console.log("save-fina--",vm.slimCdAccountDetails);

                let existingIndex = this.paymentAccountList.findIndex(paymentAccount=> Number(paymentAccount.PaymentAccountId)===Number(this.slimCdAccountDetails.clientId))
                if(existingIndex!==-1){
                     this.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "user already existed"
                     });
                     return;
                }
                  if(vm.slimCdAccountDetails.apiKey == null || vm.slimCdAccountDetails.Password == null || vm.slimCdAccountDetails.clientId == null || vm.slimCdAccountDetails.siteId == null){
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "Please enter all details!!"
                            });
                }else if(vm.slimCdAccountDetails.gatewayId == null){
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "Please select gateway type!!"
                            });
                }
               else{
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Save_Acc_Commission_Config",
                    params: {                       
                        ModuleAction: "Save_Acc_Commission_Config",                        
                        accountId: vm.slimCdAccountDetails.clientId,
                        gateWayId: 2,                        //vm.slimCdAccountDetails.gatewayId,
                        siteId: vm.slimCdAccountDetails.siteId,
                        apiKeyId: vm.slimCdAccountDetails.apiKey,
                        password: vm.slimCdAccountDetails.Password,
                        AccountName:vm.slimCdAccountDetails.AccountName,
                        statusId: 1,
                        IsDefault: 0
                    },
                    callback: function (err, response) {

                        if (err) {
                            vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error!",
                                message: "Error in creating user"
                            });
                            return
                        }
                        if (response) {
                            if (response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage) {
                             vm.$store.dispatch("toastr", {
                               type: "error",
                               message: response.recordsets[0][0].ErrorMessage,
                               header: "Error!"
                             });
                            } else {
                            console.log( "user Slim--inactive = ",response)
                            vm.$store.dispatch("toastr", {
                                type: "success",
                                header: "Success!",
                                message: "Account Added Successfully!!"
                            });
                            vm.closeSlimCdAccoutPanel();
                        }
                        vm.getIntegrationList();
                    }
                }
                }) 
            }              
            },  
            GetSlimCdAccountDetails() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations_RU",
                        PropertyId: null,
                        UnitId: null
                    },
                    callback: function (err, response) {
                        if (response[0].length) {
                            vm.slimCdAccountDetails = response[0].find(element => element.IntegrationId == 6) || {}

                        }
                        console.log("vm.slimCdAccountDetails---get----", vm.slimCdAccountDetails)

                    }
                })
                setTimeout(() => {
                    vm.openWheelHouseComponent = false;
                }, 1000);
            },
            hasSlimCdDetails() {
                console.log("slimCdAccountDetails----", this.slimCdAccountDetails, Object.keys(this.slimCdAccountDetails).length);
                return Object.keys(this.slimCdAccountDetails).length === 0;
            },
            getGatewayTypeList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "getGatewayTypeList",
                    params: {
                        ModuleAction: "getGatewayTypeList",
                    },
                    callback: function (err, response) {
                        if (err) {
                            return
                        }
                        if (response) {
                            console.log("Get gatewayList", response)
                            vm.gatewayList = response[0]

                        }
                    }
                })
            },



        },
        watch: {

        },
        computed: {
            paymentAccountList(){
                return this.$store.getters.getPaymentAccountList()
            }
        },

        mounted() {
            let vm = this;
            vm.getGatewayTypeList();

            // console.log("before-vm.finalyticAccountDetails",vm.finalyticAccountDetails.UserName, vm.finalyticAccountDetails!==null)

            // console.log("ount----",this.$route.params);
            // vm.slimCdAccountDetails = this.$route.params
            // console.log("vm.slimCdAccountDetails", vm.slimCdAccountDetails)

            // vm.GetSlimCdAccountDetails();
            // vm.hasSlimCdDetails();

        }
    };
</script>